import { createApp } from 'vue/dist/vue.esm-bundler';

// Safety patch to prevent uncaught SyntaxError in browser console when querySelectorAll('#') or querySelector('#') is called
const origQSA = Document.prototype.querySelectorAll;
Document.prototype.querySelectorAll = function (selector) {
    if (selector === '#' || selector === '') return this.querySelectorAll(':not(*)');
    try {
        return origQSA.call(this, selector);
    } catch (e) {
        if (e.name === 'SyntaxError') return this.querySelectorAll(':not(*)');
        throw e;
    }
};

const origQS = Document.prototype.querySelector;
Document.prototype.querySelector = function (selector) {
    if (selector === '#' || selector === '') return null;
    try {
        return origQS.call(this, selector);
    } catch (e) {
        if (e.name === 'SyntaxError') return null;
        throw e;
    }
};

export const app = createApp({});

window.app = app;
